import gql from 'graphql-tag'

export const addSaveOrderAsPendingQuery = gql`
  query ($cartId: String!, $shipToPreOrder: String, $sapOrderType: String, $customerOrderNumber: String) {
    addPreOrder(
      cart_id: $cartId,
      ship_to_preorder: $shipToPreOrder,
      sap_order_type: $sapOrderType,
      customer_order_number: $customerOrderNumber
    ) {
      message
    }
  }
`
